import React from 'react'
import CommonSection from '../shared/CommonSection'
import Newsletter from './../shared/Newsletter'
import {Col, Container, Row} from 'reactstrap'
import AboutServiceList from '../services/AboutServiceList';
import experienceImg from '../assets/images/experience2.png'

const About = () => {
  return (
    <>
    <CommonSection title={'About Us'} />
    <section>
        <Container>
          <Row>
            <Col lg='6'>
            <div className="experience__content">
              <h2>Providing you with a lifetime experience</h2>
              <p>Coast Camping Tours and Safaris is a premier tour company dedicated to providing exceptional travel experiences across Kenya. Founded with a passion for showcasing the country’s rich wildlife, diverse landscapes, and vibrant culture, we aim to make every adventure unforgettable. With years of experience, our team offers expertly guided safaris, cultural tours, and coastal retreats that cater to every traveler’s needs.</p>
            </div>
 
            </Col>
            <Col lg='6'>
            <div className="experience__img">
              <img src={experienceImg} alt="" />
            </div>
            </Col>
          </Row>
        </Container>
      </section>
    <section>
        <Container>
          <Row>
            
            <AboutServiceList />
          </Row>
        </Container>
      </section>
    <Newsletter/>
      
    </>
  )
}

export default About
